
import React from 'react';
import { withRouter } from 'react-router-dom';
import './interior-75-25.styles.scss'

const Interior7525Component = ({ title, id, imageUrl, bodyCopy, htmlCopy, imageLeft, history, linkUrl, match, imageHeight, imageWidth }) => (
    <section className="container-fluid cards-no-border breathing-room-bottom" >
        <div className={`${imageLeft ? "reverse-row" : ""} row container interior-row`}>
            <div className={`${imageLeft ? "left-column" : "right-column"}  col-lg-5 col-md-12 col-sm-12 vertically-center`}>
                <div className="row">
                    <div className="col-12 left-column-content interior-row-container">
                        {title &&
                        <h1 className={`${title ? "dash" : ""}`}>{title} {imageLeft}</h1>
                        }
                        {bodyCopy &&
                        <p className='interior-row-text'>{bodyCopy}</p>
                        }
                        <div dangerouslySetInnerHTML={{__html: htmlCopy}} />
                    </div>
                </div>
            </div>
            <div className={`${imageLeft ? "right-column" : "left-column"}  col-lg-7 col-md-12 col-sm-12 align-self-center`}>
                <img style={{height: imageHeight + '%', width: imageWidth + '%'}} src={`${imageUrl}`} className="" width="auto" height="auto" alt=""/>
            </div>
        </div>
    </section>
)

export default withRouter(Interior7525Component);